const OPENROUTER_URL = 'https://openrouter.ai/api/v1/chat/completions';

export async function requestOpenRouter(messages, options = {}) {
  const apiKey = process.env.REACT_APP_OPENROUTER_API_KEY;

  if (!apiKey) {
    throw new Error('Missing OpenRouter API key. Set REACT_APP_OPENROUTER_API_KEY in your environment.');
  }

  const response = await fetch(OPENROUTER_URL, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${apiKey}`,
      'Content-Type': 'application/json',
      'HTTP-Referer': 'https://greenplan.app',
      'X-Title': 'GreenPlan',
    },
    body: JSON.stringify({
      model: options.model || 'openrouter/free',
      messages,
      temperature: options.temperature ?? 0.6,
      max_tokens: options.maxTokens ?? 450,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    const message = data?.error?.message || 'OpenRouter request failed.';
    throw new Error(message);
  }

  return data?.choices?.[0]?.message?.content || '';
}
